import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import CommonTable from "../../../components/comman/CommonTable";
import { formatTo12HourTime } from "../../../utility/CommonFunctions";

const AttendanceDashboard = ({ siteId }) => {
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    attendanceList: [],
  });

  useEffect(() => {
    GetAttendance();
  }, [siteId]);

  const GetAttendance = async () => {
    const Url = `${apiUrl.get_attendance}?myAttendance=false${siteId ? `&siteId=${siteId}` : ""}&pageNumber=1&pageSize=5`;

    const options = { method: "GET" };

    callApi(Url, options).then((res) => {
      if (res?.status) {
        const today = moment().format("YYYY-MM-DD"); // Get today's date in YYYY-MM-DD format
        const attendanceData = res?.data?.attendance || [];
        const newData = attendanceData
          ?.filter(
            (i) =>
              i.attendances[0]?.checkInTime &&
              moment(i.attendances[0]?.checkInTime).format("YYYY-MM-DD") ===
              today
          ) // Compare only the date
          ?.slice(0, 3)
          .map((item, i) => ({
            ...item,
            indexNo: i + 1,
            empNameWithImage: item?.name + "##" + item?.profilePhoto,
            checkIn:
              item?.attendances[0]?.checkInTime &&
              formatTo12HourTime(item?.attendances[0]?.checkInTime),
            checkOut:
              item?.attendances[0]?.checkOutTime &&
              formatTo12HourTime(item?.attendances[0]?.checkOutTime),
            attendanceStatus: item?.attendances?.[0]
              ? item?.attendances?.[0]?.status
              : 2,
          }));
        setPageStates((prevState) => ({
          ...prevState,
          attendanceList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeCode", label: "Emp. Code" },
    { value: "attendanceStatus", label: "Status" },
    { value: "checkIn", label: "Check In" },
    { value: "checkOut", label: "Check Out" },
  ];

  return (
    <div className="col-12 col-lg-8">
      <div className="card h-100">
        <div className="card-body h-100">
          <div className="card-head">
            <h3 className="card-title">Today's Team Attendance</h3>
            <Link
              to={RoutesLink.attendance_admin}
              type="button"
              className="btn btn-outline-primary py-1"
            >
              View All
            </Link>
          </div>
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates?.attendanceList}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendanceDashboard;
